import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import styles from "./TCSModal.module.css";
import { Button } from "react-bootstrap";
import SignInInput from "../../common/SigninInput/signinInput";
import DateInputWithCalendar from "../../common/DateCalender/DateCalender";
import { format } from "date-fns";
const TCSModal = ({
  isOpen,
  onRequestClose,
  sources,
  onSubmit,
  modalType,
  setTcsModalType,
  allSources = [],
  loading,
  onRemoveSource,
}) => {
  useEffect(() => {
    if (sources.length === 0) {
      addNewSource();
    } else {
      setTcsModalType("view");
    }
  }, [sources]);

  const [localSources, setLocalSources] = useState(sources || []);

  const addNewSource = () => {
    const newSource = {
      id: Date.now(),
      amountDeclared: "",
      sourceType: "",
      referenceId: "",
      recordDate: "",
    };
    setLocalSources([newSource]);
    setTcsModalType("add");
  };

  // const removeSource = (id) => {
  //   // Call parent's remove handler to update the allSources state
  //   if (onRemoveSource) {
  //     onRemoveSource(id);
  //   }
  //   // Also update local sources if needed
  //   setLocalSources(localSources.filter((source) => source.id !== id));
  // };

  const updateSource = (id, field, value) => {
    setLocalSources(
      localSources.map((source) =>
        source.id === id ? { ...source, [field]: value } : source
      )
    );
  };

  const BackTOView = () => {
    setTcsModalType("view");
  };

  const handleSubmit = () => {
    onSubmit(localSources);
    // Only close modal in "view" mode (final submit)
    // In "add" mode, parent will handle transition to view mode
    if (modalType === "view") {
      onRequestClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="TCS Sources Modal"
      className={styles.modalBase}
      overlayClassName={styles.overlayBase}
      shouldCloseOnOverlayClick={true}
      closeTimeoutMS={300}
    >
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Additional TCS Sources</h2>
          <Button className={styles.closeButton} onClick={onRequestClose}>
            ✕
          </Button>
        </div>

        <div className={styles.modalBody}>
          {modalType === "add" ? (
            // Add mode: Show form fields
            <>
              {localSources?.map((source, index) => (
                <div key={source.id} className={styles.sourceCard}>
                  <div className={styles.sourceHeader}>
                    <span className={styles.sourceLabel}>
                      Source {allSources?.length + 1}
                    </span>
                  </div>

                  <SignInInput
                    label="Transaction amount in rupees"
                    type="text"
                    placeholder="Enter amount"
                    value={source.amountDeclared}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      if (value.length <= 7) {
                        updateSource(source.id, "amountDeclared", value);
                      }
                    }}
                    containerClasses={styles.formGroup}
                  />

                  <SignInInput
                    label="Source Bank"
                    type="text"
                    placeholder="Enter source"
                    value={source.sourceType}
                    onChange={(e) =>
                      updateSource(source.id, "sourceType", e.target.value)
                    }
                    containerClasses={styles.formGroup}
                  />

                  <SignInInput
                    label="Transaction Reference ID"
                    type="text"
                    placeholder="Enter reference ID"
                    value={source.referenceId}
                    onChange={(e) =>
                      updateSource(source.id, "referenceId", e.target.value)
                    }
                    containerClasses={styles.formGroup}
                  />
                    <div className={styles.dateGroup}>
                        <DateInputWithCalendar
                          label="Transaction Date"
                          placeholder="Select Transaction Date"
                          name="recordDate"
                          value={source.recordDate}
                          onHandleDate={(date) =>
                            updateSource(
                              source.id,
                              "recordDate",
                              format(date, "yyyy-MM-dd")
                            )
                          }
                        />
                    </div>
                </div>
              ))}
            </>
          ) : (
            // View mode: Show summary cards from allSources
            <div className={styles.summaryParent}>
              {allSources.map((source, index) => (
                <div key={source.id} className={styles.summaryCard}>
                  <div className={styles.summaryContent}>
                    <div className={styles.summaryText}>
                      <span className={styles.summaryLabel}>
                        Source {index + 1}:
                      </span>
                      <span className={styles.summaryAmount}>
                        ₹{Number(source.amountDeclared).toLocaleString('en-IN')}
                      </span>
                    </div>
                    {/* {allSources.length > 1 && ( */}
                    {/* <span
                      className={styles.removeButton}
                      onClick={() => removeSource(source.id)}
                    >
                      Remove
                    </span> */}
                    {/* )} */}
                  </div>
                </div>
              ))}

              <div className={styles.addMoreContainer}>
                <button className={styles.addMoreButton} onClick={addNewSource}>
                  +Add More
                </button>
              </div>
            </div>
          )}
        </div>

        <div className={styles.modalFooter}>
          {modalType === "add" && (
            <Button className={styles.backButton} onClick={BackTOView}>
              Back
            </Button>
          )}
          <Button className={styles.submitButton} onClick={handleSubmit} disabled={loading}>
            {loading && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              />
            )}
            {modalType === "add" ? "Add Source" : "Submit"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default TCSModal;
